import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";

var _this = this;

import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = _Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as React from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import Icon from '../icon';
import request from './request';
import verifyFile from './verify-file';
import scanFiles from './scan-files';
import { getBase64, getFileSize } from './utils';
import Image from '../image';
import Progress from '../progress';

var getUid = function (index, now) {
  return function () {
    var _context;

    return _concatInstanceProperty(_context = "kd-upload-".concat(now, "-")).call(_context, ++index);
  };
}(0, +new Date());

var reqs = {};

function abort(file) {
  if (file) {
    var uid = file.uid;

    if (reqs[uid] && reqs[uid].abort) {
      reqs[uid].abort();
    }

    delete reqs[uid];
  } else {
    _Object$keys(reqs).forEach(function (uid) {
      if (reqs[uid] && reqs[uid].abort) {
        reqs[uid].abort();
      }

      delete reqs[uid];
    });
  }
}

var InternalUpload = function InternalUpload(props, ref) {
  var _context5, _classNames, _context6, _context7;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps;

  var innerRef = React.useRef();
  var mergedRef = ref || innerRef;
  var allProps = getCompProps('Upload', userDefaultProps, props); // 属性需要合并一遍用户定义的默认属性

  var type = allProps.type,
      style = allProps.style,
      accept = allProps.accept,
      children = allProps.children,
      disabled = allProps.disabled,
      multiple = allProps.multiple,
      listType = allProps.listType,
      onRemove = allProps.onRemove,
      directory = allProps.directory,
      className = allProps.className,
      itemRender = allProps.itemRender,
      showUploadList = allProps.showUploadList,
      customPrefixcls = allProps.prefixCls;

  var _React$useState = React.useState(props.fileList || props.defaultFileList || []),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      fileList = _React$useState2[0],
      setFileList = _React$useState2[1];

  React.useEffect(function () {
    props.fileList && setFileList(props.fileList);
  }, [props.fileList]);
  React.useEffect(function () {
    return abort;
  }, []);

  var onClick = function onClick(e) {
    allProps.onClick && allProps.onClick(e);
  };

  var onChange = function onChange(e) {
    var files = _sliceInstanceProperty(Array.prototype).call(e.target.files);

    e.target.value = '';
    uploadFiles(files);
  };

  var onFileListChange = function onFileListChange(file, fileList, event) {
    props.fileList === undefined && setFileList(fileList);
    props.onChange && props.onChange({
      file: file,
      fileList: fileList,
      event: event
    });
  };

  var uploadFiles = function uploadFiles(files) {
    var _context2;

    files.forEach(function (file) {
      file.originFileObj = new File([file], file.type);
      file.uid = getUid();
      file.status = 'notStart';
      file.fileName = allProps.name || file.name;
    });

    var newFileList = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(fileList), _toConsumableArray(files));

    files.forEach(function (file) {
      props.fileList === undefined && setFileList(fileList);
      upload(file, newFileList);
    });
  };

  var upload = function upload(file, fileList) {
    if (props.beforeUpload) {
      var before = props.beforeUpload(file, fileList);

      if (before && typeof before !== 'boolean' && before.then) {
        before.then(function (processedFile) {
          var processedFileType = Object.prototype.toString.call(processedFile);

          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
            post(processedFile, fileList);
          } else {
            post(file, fileList);
          }
        }).catch(function (e) {
          console.log(e);
        });
      } else if (before !== false) {
        _Promise.resolve().then(function () {
          post(file, fileList);
        });
      }
    } else {
      _Promise.resolve().then(function () {
        post(file, fileList);
      });
    }
  };

  var post = function post(file, fileList) {
    var action = allProps.action,
        method = allProps.method,
        headers = allProps.headers,
        _onError = allProps.onError,
        onStart = allProps.onStart,
        _onSuccess = allProps.onSuccess,
        _onProgress = allProps.onProgress,
        withCredentials = allProps.withCredentials,
        _allProps$transformFi = allProps.transformFile,
        transformFile = _allProps$transformFi === void 0 ? function (originFile) {
      return originFile;
    } : _allProps$transformFi;
    file.percent = 0;
    file.status = 'uploading';
    onFileListChange(file, fileList);
    new _Promise(function (resolve) {
      var actionRet = action;

      if (typeof actionRet === 'function') {
        actionRet = actionRet(file);
      }

      return resolve(actionRet);
    }).then(function (action) {
      var uid = file.uid;

      var transform = _Promise.resolve(transformFile(file)).then(function (transformedFile) {
        var data = props.data;

        if (typeof data === 'function') {
          data = data(transformedFile);
        }

        return _Promise.all([transformedFile, data]);
      }).catch(function (e) {
        console.error(e);
      });

      transform.then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            transformedFile = _ref2[0],
            data = _ref2[1];

        var requestOptions = {
          data: data,
          action: action,
          method: method,
          headers: headers,
          withCredentials: withCredentials,
          file: transformedFile,
          filename: file.fileName,
          onProgress: function onProgress(event) {
            file.status = 'uploading';
            file.percent = event.percent;
            _onProgress && _onProgress(event, file);
            fileList = _mapInstanceProperty(fileList).call(fileList, function (fileItem) {
              return fileItem.uid === file.uid ? file : fileItem;
            });
            onFileListChange(file, fileList, event);
          },
          onError: function onError(event, ret) {
            file.status = 'error';
            file.error = event;
            delete reqs[uid];
            _onError && _onError(event, ret, file);
            fileList = _mapInstanceProperty(fileList).call(fileList, function (fileItem) {
              return fileItem.uid === file.uid ? file : fileItem;
            });
            onFileListChange(file, fileList);
          },
          onSuccess: function onSuccess(response, xhr) {
            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var url;
              return _regeneratorRuntime.wrap(function _callee$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      file.status = 'done';
                      file.response = response;
                      file.xhr = xhr;

                      if (!(/image/.test(file.type) && !file.url)) {
                        _context3.next = 8;
                        break;
                      }

                      _context3.next = 6;
                      return getBase64(file);

                    case 6:
                      url = _context3.sent;
                      file.url = url;

                    case 8:
                      delete reqs[uid];
                      _onSuccess && _onSuccess(response, file, xhr);
                      fileList = _mapInstanceProperty(fileList).call(fileList, function (fileItem) {
                        return fileItem.uid === file.uid ? file : fileItem;
                      });
                      onFileListChange(file, fileList);

                    case 12:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee);
            }));
          }
        };
        onStart && onStart(file);
        reqs[uid] = request(requestOptions);
      });
    });
  };

  var handleRemove = function handleRemove(file, e) {
    e.preventDefault();

    var files = _filterInstanceProperty(fileList).call(fileList, function (fileItem) {
      return fileItem.uid !== file.uid;
    });

    if (onRemove) {
      var remove = onRemove(file);

      if (remove && typeof remove !== 'boolean' && remove.then) {
        remove.then(function (flag) {
          if (flag) {
            onFileListChange(file, files);
            abort(file);
          }
        }).catch(function (e) {
          console.log(e);
        });
      } else if (remove !== false) {
        onFileListChange(file, files);
        abort(file);
      }
    } else {
      onFileListChange(file, files);
      abort(file);
    }
  };

  var handleReUpload = function handleReUpload(file, e) {
    e.preventDefault();
    file.percent = 0;
    file.status = 'uploading';

    var files = _mapInstanceProperty(fileList).call(fileList, function (fileItem) {
      return fileItem.uid === file.uid ? file : fileItem;
    });

    onFileListChange(file, files);
    upload(file, files);
  };

  var prefixCls = getPrefixCls(pkgPrefixCls, 'upload', customPrefixcls);
  var inputFileProps = {
    accept: accept,
    onClick: onClick,
    onChange: onChange,
    disabled: disabled,
    multiple: multiple,
    directory: directory ? 'directory' : undefined,
    webkitdirectory: directory ? 'webkitdirectory' : undefined
  };
  var dragEvents = {};

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hover = _React$useState4[0],
      setHover = _React$useState4[1];

  if (type === 'drag') {
    var onFileDrop = function onFileDrop(e) {
      e.preventDefault();
      setHover(false);

      if (directory) {
        scanFiles(_sliceInstanceProperty(Array.prototype).call(e.dataTransfer.items), function (file) {
          return verifyFile(file, accept);
        }, function (file) {
          file.originFileObj = new File([file], file.type);
          file.uid = getUid();
          file.status = 'notStart';
          file.fileName = allProps.name || file.name;
          fileList.push(file);
          props.fileList === undefined && setFileList(fileList);
          upload(file, fileList);
        });
      } else {
        var _context4;

        var files = _filterInstanceProperty(_context4 = _sliceInstanceProperty(Array.prototype).call(e.dataTransfer.files)).call(_context4, function (file) {
          return verifyFile(file, accept);
        });

        if (multiple === false) {
          files = _sliceInstanceProperty(files).call(files, 0, 1);
        }

        uploadFiles(files);
      }
    };

    var onFileLeave = function onFileLeave(e) {
      e.preventDefault();
      e.type === 'dragover' ? setHover(true) : setHover(false);
    };

    dragEvents.onDrop = onFileDrop;
    dragEvents.onDragOver = onFileLeave;
    dragEvents.onDragLeave = onFileLeave;
  }

  React.useEffect(function () {
    if (type === 'drag') {
      var stopDrop = function stopDrop(e) {
        return e.preventDefault();
      };

      document.addEventListener('drop', stopDrop);
      document.addEventListener('dragover', stopDrop);
      return function () {
        document.removeEventListener('drop', stopDrop);
        document.removeEventListener('dragover', stopDrop);
      };
    }
  }, [type]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, {
      disabled: disabled
    }, className),
    style: style
  }, listType === 'text' && /*#__PURE__*/React.createElement("label", _extends({
    className: classNames((_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context5 = "".concat(prefixCls, "-")).call(_context5, type), true), _defineProperty(_classNames, "hover", hover), _classNames))
  }, dragEvents), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-handle")
  }, children), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-input")
  }, /*#__PURE__*/React.createElement("input", _extends({
    title: "",
    type: "file"
  }, inputFileProps, {
    ref: mergedRef
  })))), (listType === 'picture' || !(listType === 'text' && (!showUploadList || !fileList.length))) && /*#__PURE__*/React.createElement("ul", {
    className: _concatInstanceProperty(_context6 = "".concat(prefixCls, "-")).call(_context6, listType, "-list")
  }, listType === 'picture' && children && /*#__PURE__*/React.createElement("li", {
    className: classNames(_concatInstanceProperty(_context7 = "".concat(prefixCls, "-")).call(_context7, listType, "-list-item"))
  }, /*#__PURE__*/React.createElement("label", {
    className: "".concat(prefixCls, "-select")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-handle")
  }, children), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-input")
  }, /*#__PURE__*/React.createElement("input", _extends({
    title: "",
    type: "file"
  }, inputFileProps, {
    ref: mergedRef
  }))))), showUploadList && _mapInstanceProperty(fileList).call(fileList, function (file) {
    return itemRender ? itemRender( /*#__PURE__*/React.createElement(Item, _extends({}, {
      file: file,
      prefixCls: prefixCls,
      listType: listType,
      handleReUpload: handleReUpload,
      handleRemove: handleRemove
    })), file, setFileList) : /*#__PURE__*/React.createElement(Item, _extends({
      key: file.uid
    }, {
      file: file,
      prefixCls: prefixCls,
      listType: listType,
      handleReUpload: handleReUpload,
      handleRemove: handleRemove
    }));
  })));
};

var Item = function Item(_ref3) {
  var _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16, _context17, _context18, _context19, _context20;

  var file = _ref3.file,
      prefixCls = _ref3.prefixCls,
      listType = _ref3.listType,
      handleReUpload = _ref3.handleReUpload,
      handleRemove = _ref3.handleRemove;
  var mapStatus = {
    uploading: 'loadding',
    error: 'warning-solid',
    done: 'attachment',
    success: 'attachment',
    notStart: 'attachment'
  };
  return /*#__PURE__*/React.createElement("li", {
    className: classNames(_concatInstanceProperty(_context8 = "".concat(prefixCls, "-")).call(_context8, listType, "-list-item"), {
      error: file.status === 'error'
    })
  }, listType === 'text' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: _concatInstanceProperty(_context9 = "".concat(prefixCls, "-")).call(_context9, listType, "-list-item-icon")
  }, /*#__PURE__*/React.createElement(Icon, {
    spin: file.status === 'uploading',
    type: mapStatus[file.status]
  })), /*#__PURE__*/React.createElement("span", {
    className: _concatInstanceProperty(_context10 = "".concat(prefixCls, "-")).call(_context10, listType, "-list-item-name"),
    title: file.name
  }, file.name), /*#__PURE__*/React.createElement("span", {
    className: _concatInstanceProperty(_context11 = "".concat(prefixCls, "-")).call(_context11, listType, "-list-item-size")
  }, "(", getFileSize(file.size), ")"), /*#__PURE__*/React.createElement("div", {
    className: _concatInstanceProperty(_context12 = "".concat(prefixCls, "-")).call(_context12, listType, "-list-item-action")
  }, file.status === 'error' && /*#__PURE__*/React.createElement("a", {
    href: "true",
    className: _concatInstanceProperty(_context13 = "".concat(prefixCls, "-")).call(_context13, listType, "-list-item-reupload"),
    onClick: handleReUpload.bind(_this, file)
  }, "\u91CD\u65B0\u4E0A\u4F20"), /*#__PURE__*/React.createElement("a", {
    href: "true",
    className: _concatInstanceProperty(_context14 = "".concat(prefixCls, "-")).call(_context14, listType, "-list-item-delete"),
    onClick: handleRemove.bind(_this, file)
  }, "\u5220\u9664"))) : file.status === 'uploading' ? /*#__PURE__*/React.createElement("div", {
    className: _concatInstanceProperty(_context15 = "".concat(prefixCls, "-")).call(_context15, listType, "-list-item-loading")
  }, /*#__PURE__*/React.createElement(Progress, {
    percent: file.percent,
    textMap: ['文件上传中'],
    showInfo: false
  })) : file.status === 'error' ? /*#__PURE__*/React.createElement("div", {
    className: _concatInstanceProperty(_context16 = "".concat(prefixCls, "-")).call(_context16, listType, "-list-item-error")
  }, /*#__PURE__*/React.createElement("div", {
    className: _concatInstanceProperty(_context17 = "".concat(prefixCls, "-")).call(_context17, listType, "-list-item-error-text")
  }, /*#__PURE__*/React.createElement(Icon, {
    type: mapStatus[file.status],
    style: {
      verticalAlign: 'top'
    }
  }), "\u4E0A\u4F20\u5931\u8D25"), /*#__PURE__*/React.createElement("div", {
    className: _concatInstanceProperty(_context18 = "".concat(prefixCls, "-")).call(_context18, listType, "-list-item-action")
  }, /*#__PURE__*/React.createElement("a", {
    href: "true",
    className: _concatInstanceProperty(_context19 = "".concat(prefixCls, "-")).call(_context19, listType, "-list-item-reupload"),
    onClick: handleReUpload.bind(_this, file)
  }, "\u91CD\u65B0\u4E0A\u4F20"), /*#__PURE__*/React.createElement("a", {
    href: "true",
    className: _concatInstanceProperty(_context20 = "".concat(prefixCls, "-")).call(_context20, listType, "-list-item-delete"),
    onClick: handleRemove.bind(_this, file)
  }, "\u5220\u9664"))) : /*#__PURE__*/React.createElement(Image, {
    previewType: "upload",
    name: file.name,
    size: getFileSize(file.size),
    src: file.thumbUrl || file.url,
    style: {
      width: '100%',
      height: '100%'
    },
    operations: [/*#__PURE__*/React.createElement(Icon, {
      key: "1",
      type: "delete",
      onClick: handleRemove.bind(_this, file)
    })]
  }));
};

var Upload = /*#__PURE__*/React.forwardRef(InternalUpload);
Upload.displayName = 'Upload';
export default Upload;